/* The `passwordCriteria` object is defining a set of criteria for creating a strong password. Each
key-value pair in the object represents a specific criterion. */
export const passwordCriteria = {
    "At least 8 characters": {
        regex: /^.{8,}$/,
    },
    "Both uppercase and lowercase letters (e.g., Aa)": {
        regex: /^(?=.*[a-z])(?=.*[A-Z])/,
    },
    "At least one number (e.g., 123)": {
        regex: /\d/,
    },
    "At least one special character (e.g., !@#$)": {
        regex: /[!@#$%^&*()\-_+=\[\]{}|\\\/:;"'<>,.?~`¬¢£€¥§©®™°µ×÷]/,
    },
};